import React, { useEffect, useState, createContext } from 'react';
import firebase from '../config/firebase.config';

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
  const [userUid, setUserUid] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      setUserUid(user);
      setIsInitialized(true);
    });
  }, []);

  const isLoggedIn = userUid === null ? false : true;

  function signUp(email, password) {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .catch((error) => {
        alert(error.message);
      });
  }

  function signIn(email, password) {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch((error) => {
        alert(error.message);
      });
  }

  function signOut() {
    firebase.auth().signOut();
    setUserUid(false);
  }

  const value = {
    signUp,
    signIn,
    signOut,
    userUid,
    isLoggedIn,
    isInitialized,
  };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserContextProvider;
